// @ts-nocheck



import React from 'react';



import { maintenanceWorkTypeApi } from './../../lib/api';
import AutocompleteSelect from './AutocompleteSelect';

export default (selectProps) =>
<AutocompleteSelect
  placeholder="Выберите вид работ"
  fetch={maintenanceWorkTypeApi.fetchMaintenanceTypeWork}
  fetchSingle={maintenanceWorkTypeApi.getMaintenanceTypeWork}
  notFoundText="Виды работ не найдены"
  renderOption={(maintenanceWorkType, Option) =>
  <Option key={maintenanceWorkType.id} value={maintenanceWorkType.id}>
        {maintenanceWorkType.name}
      </Option>
  }
  {...selectProps} />;
